/* Routing */
import {Link, Outlet, useLocation, useNavigate, useParams} from "react-router-dom";
/* Components */
import Menu from "./navigation/Menu";
/* Contexts */
import { DeceasedProvider } from "../../context/DeceasedProvider";
import useDeceased from "../../hooks/useDeceased";
import useAuth from "../../hooks/useAuth";
import { PagerProvider } from "../../context/PagerProvider";
import {DataProvider} from "../../context/DataProvider";
import MentionsLegales from "../../pages/MentionsLegales";


export default function Layout() {
    const { deceasedInfos, deceased } = useDeceased();
    const {pathname} = useLocation();
    const { id } = useParams();
    const { auth } = useAuth();
    const navigate = useNavigate();
    const thisYear = new Date().getFullYear();

    const handleNavigateBack = () => {
        if (pathname.includes("/faire-part")) {
            navigate(`/defunt/${id}`)
        } else {
            navigate(-1)
        }
    }

    return (
        <>
            <div>
                {
                    (!pathname.includes("/pro/login") && !pathname.includes("/familles/login") && !pathname.includes("/admin")) &&
                    <Menu user={ auth?.username } />
                }
                <PagerProvider>
                    <DeceasedProvider deceased={{deceasedInfos, deceased}}>
                        <DataProvider>
                            <Outlet />
                        </DataProvider>
                    </DeceasedProvider>
                </PagerProvider>
            </div>
            <span className="footer">{thisYear} - Obsèques en France - <Link to="/mentions-legales" target="_blank"> Mentions légales et politique de confidentialité</Link></span>
        </>
    )
}
